import React, { useEffect, useMemo, useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import "./LoftDetails.css";

import heroBg2 from "../../assets/loftone.webp";
import heroBg3 from "../../assets/ltwo.webp";
import heroBg4 from "../../assets/lone.webp";

/* ---------------- Config ---------------- */
const FORM_ENDPOINT = "https://formspree.io/f/xrbybqkr";
const RECAPTCHA_SITE_KEY =
  process.env.REACT_APP_RECAPTCHA_SITE_KEY ||
  "6Ldbb9QrAAAAAPRQP_QAThmTFAHRnSn5R3jJOHWC";

/* ---------------- Icons ---------------- */
const Icon = ({ name }) => {
  const icons = {
    arrowLeft: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M19 12H5M12 19l-7-7 7-7" />
      </svg>
    ),
    arrowRight: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M5 12h14M12 5l7 7-7 7" />
      </svg>
    ),
    mapPin: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M21 10c0 6-9 12-9 12S3 16 3 10a9 9 0 1 1 18 0z" />
        <circle cx="12" cy="10" r="3" />
      </svg>
    ),
    image: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <rect x="3" y="3" width="18" height="18" rx="2" />
        <circle cx="8.5" cy="8.5" r="1.5" />
        <path d="M21 15l-5-5L5 21" />
      </svg>
    ),
    check: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M20 6L9 17l-5-5" />
      </svg>
    ),
    close: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M18 6L6 18M6 6l12 12" />
      </svg>
    ),
    send: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M22 2L11 13" />
        <path d="M22 2l-7 20-4-9-9-4 20-7z" />
      </svg>
    ),
    phone: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
      </svg>
    ),
    mail: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
        <polyline points="22,6 12,13 2,6" />
      </svg>
    ),
    user: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
      </svg>
    ),
    tag: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L3 13.99V3h10.99l7.17 7.17a2 2 0 0 1 0 2.83z" />
        <circle cx="7.5" cy="7.5" r="1.5" />
      </svg>
    ),
    ruler: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <rect x="2" y="6" width="20" height="12" rx="2" />
        <path d="M6 6v4M10 6v2M14 6v4M18 6v2" />
      </svg>
    ),
    building: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <rect x="3" y="3" width="18" height="18" rx="2" />
        <path d="M7 7h.01M11 7h.01M15 7h.01M7 11h.01M11 11h.01M15 11h.01M7 15h10" />
      </svg>
    ),
    car: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M3 13l2-5a3 3 0 0 1 3-2h6a3 3 0 0 1 3 2l2 5" />
        <path d="M5 13h14v6H5z" />
        <circle cx="7.5" cy="19" r="1" />
        <circle cx="16.5" cy="19" r="1" />
      </svg>
    ),
    flame: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M8 14a4 4 0 1 0 8 0c0-3-3-5-3-8-2 1-5 3-5 8z" />
      </svg>
    ),
    map: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M9 18l6 3 6-3V3l-6 3-6-3-6 3v15z" />
        <path d="M9 3v15M15 6v15" />
      </svg>
    ),
  };
  return icons[name] || null;
};

/* ---------------- Simple Lightbox ---------------- */
function Lightbox({ images = [], index = 0, onClose, onPrev, onNext }) {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
      if (e.key === "ArrowLeft") onPrev?.();
      if (e.key === "ArrowRight") onNext?.();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose, onPrev, onNext]);

  if (!images.length) return null;
  const src = images[index] || images[0];

  return (
    <div className="loft-lightbox" onClick={onClose} role="dialog" aria-modal="true">
      <div className="loft-lightbox-inner" onClick={(e) => e.stopPropagation()}>
        <button className="loft-lightbox-close" onClick={onClose} aria-label="Close">
          <Icon name="close" />
        </button>
        <button className="loft-lightbox-nav prev" onClick={onPrev} aria-label="Previous">
          <Icon name="arrowLeft" />
        </button>
        <img className="loft-lightbox-img" src={src} alt="Large preview" />
        <button className="loft-lightbox-nav next" onClick={onNext} aria-label="Next">
          <Icon name="arrowRight" />
        </button>
        <div className="loft-lightbox-counter">
          {index + 1} / {images.length}
        </div>
      </div>
    </div>
  );
}

/* ---------------- Main Page ---------------- */
export default function LoftDetails() {
  const sampleImages = [heroBg2, heroBg3, heroBg4];

  const property = {
    title: "Loft",
    Status: "Upcoming",
    livingArea: 1200,
    propertyType: "Apartment",
    parking: "One parking space included in rent",
    heating: "Central",
    neighborhood: "Downtown",
    description: [
      "All loft units are approximately 1200 square feet and range in price from $2000 to $2700.",
      "Security deposit is $1,300. Pet Deposit: $500, $250 refundable contingent on the property’s returned condition.",
      "Water, sewer and garbage included. One parking space is included in the rental cost. If available, additional spaces are $125.00 a month.",
      "Some amenities include: jetted bathtubs, hardwood floors, high-speed internet available, many with water views, one- and two-bedroom units, washers/dryers in each unit, top-floor units with skylights, an exercise and activity room, garage parking in the building, kitchen islands with pot and pan racks, on the New Tacoma Link Route and Union Station stop, convenient to UW Tacoma, museums, and shops."
    ],
    features: [
      "One Parking Space Included in Rent",
      "Hospital",
      "No pet rent monthly",
      "Museum",
      "Non-smoking building",
      "Private Gym",
      "Garage",
      "Light Rail",
      "Park",
    ],
    contact: {
      phone: "253-627-2663",
      email: "info@harmon.property",
      manager: "Suzanne Steliga",
    },
  };

  const [activeIdx, setActiveIdx] = useState(0);
  const [showApply, setShowApply] = useState(false);
  const [lbOpen, setLbOpen] = useState(false);
  const [lbIndex, setLbIndex] = useState(0);

  // Inline success banner control
  const [applySuccess, setApplySuccess] = useState(false);
  const successTimerRef = useRef(null);

  // Form + captcha state
  const [applyError, setApplyError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [captchaToken, setCaptchaToken] = useState(null);
  const recaptchaRef = useRef(null);

  const thumbsRef = useRef(null);

  const mainImage = useMemo(
    () => sampleImages[activeIdx] || sampleImages[0],
    [sampleImages, activeIdx]
  );

  useEffect(() => {
    const el = thumbsRef.current?.querySelector(`[data-index="${activeIdx}"]`);
    if (el) el.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
  }, [activeIdx]);

  useEffect(() => {
    return () => {
      if (successTimerRef.current) window.clearTimeout(successTimerRef.current);
    };
  }, []);

  const dash = (v) => (v === null || v === undefined || v === "" ? "—" : v);

  const handleApplySubmit = async (e) => {
    e.preventDefault();
    setApplyError(null);

    if (!captchaToken) {
      setApplyError("Please complete the reCAPTCHA.");
      return;
    }

    setIsSubmitting(true);
    try {
      const formEl = e.currentTarget;
      const formData = new FormData(formEl);

      // Helpful metadata for your inbox
      formData.append("_subject", "Loft Inquiry via Harmon Property");
      formData.append("property", property.title);

      // Required for Formspree + reCAPTCHA v2
      formData.append("g-recaptcha-response", captchaToken);

      const res = await fetch(FORM_ENDPOINT, {
        method: "POST",
        headers: { Accept: "application/json" },
        body: formData,
      });

      if (!res.ok) {
        const data = await res.json().catch(() => null);
        throw new Error(data?.error || "Submission failed. Please try again.");
      }

      // Success UX
      formEl.reset();
      setShowApply(false);
      setApplySuccess(true);

      // Reset captcha widget + token
      recaptchaRef.current?.reset();
      setCaptchaToken(null);

      if (successTimerRef.current) window.clearTimeout(successTimerRef.current);
      successTimerRef.current = window.setTimeout(() => setApplySuccess(false), 5000);
    } catch (err) {
      setApplyError(err.message || "Something went wrong. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="loft-wrap">
      <div className="loft-container">
        {/* Header */}
        <header className="loft-header">
          <div className="loft-header-left">
            <h1 className="loft-title">{property.title}</h1>
          </div>
        </header>

        {/* Gallery */}
        <section className="loft-gallery">
          <div
            className="loft-mainimg"
            style={{ backgroundImage: `url(${mainImage})` }}
            role="img"
            aria-label="Property main image"
          >
            {sampleImages.length > 1 && (
              <>
                <button
                  className="loft-nav prev"
                  onClick={() => setActiveIdx((p) => (p - 1 + sampleImages.length) % sampleImages.length)}
                  aria-label="Previous image"
                >
                  <Icon name="arrowLeft" />
                </button>
                <button
                  className="loft-nav next"
                  onClick={() => setActiveIdx((p) => (p + 1) % sampleImages.length)}
                  aria-label="Next image"
                >
                  <Icon name="arrowRight" />
                </button>
              </>
            )}
            {sampleImages.length > 1 && (
              <div className="loft-gallery-counter">
                {activeIdx + 1} / {sampleImages.length}
              </div>
            )}
          </div>

          <div className="loft-thumbs" ref={thumbsRef}>
            {sampleImages.length ? (
              sampleImages.map((src, i) => (
                <button
                  key={i}
                  data-index={i}
                  className={`loft-thumb ${i === activeIdx ? "is-active" : ""}`}
                  onClick={() => setActiveIdx(i)}
                  aria-label={`Show image ${i + 1}`}
                  onDoubleClick={() => {
                    setLbIndex(i);
                    setLbOpen(true);
                  }}
                >
                  <img src={src} alt={`Thumbnail ${i + 1}`} loading="lazy" />
                </button>
              ))
            ) : (
              <div className="loft-thumb-empty">
                <Icon name="image" /> No images
              </div>
            )}
          </div>
        </section>

        {/* Specs */}
        <section className="loft-specs">
          <div className="loft-specs-item">
            <div className="loft-specs-icon"><Icon name="tag" /></div>
            <div className="loft-specs-content">
              <div className="loft-specs-label">Status</div>
              <div className="loft-specs-value">{dash(property.Status)}</div>
            </div>
          </div>

          <div className="loft-specs-item">
            <div className="loft-specs-icon"><Icon name="building" /></div>
            <div className="loft-specs-content">
              <div className="loft-specs-label">Property Type</div>
              <div className="loft-specs-value">{dash(property.propertyType)}</div>
            </div>
          </div>

          <div className="loft-specs-item">
            <div className="loft-specs-icon"><Icon name="car" /></div>
            <div className="loft-specs-content">
              <div className="loft-specs-label">Parking</div>
              <div className="loft-specs-value">{dash(property.parking)}</div>
            </div>
          </div>
        </section>

        {/* Content */}
        <div className="loft-content">
          <main className="loft-main">
            <section className="loft-card">
              <h2 className="loft-h2">Property Description</h2>
              {property.description.map((p, i) => (
                <p key={i} className="loft-text">{p}</p>
              ))}
            </section>

            <section className="loft-card">
              <h2 className="loft-h2">Features</h2>
              <ul className="loft-list loft-list--stack">
                {property.features.map((f, i) => (
                  <li key={i}>
                    <span className="loft-li-ic"><Icon name="check" /></span>
                    <span className="loft-li-text">{f}</span>
                  </li>
                ))}
              </ul>
            </section>
          </main>

          {/* Sidebar */}
          <aside className="loft-aside">
            <div className="loft-aside-card loft-sticky">
              <h3 className="loft-aside-title">Interested?</h3>

              {/* Inline success message for 5s after submit */}
              {applySuccess ? (
                <div className="loft-inlineNotice" role="status" aria-live="polite">
                  <div className="loft-inlineNotice__icon"><Icon name="check" /></div>
                  <div className="loft-inlineNotice__body">
                    <div className="loft-inlineNotice__title">Message sent successfully</div>
                    <div className="loft-inlineNotice__sub">We’ll get back to you soon.</div>
                  </div>
                </div>
              ) : (
                <>
                  <p className="loft-aside-text">
                    Send a quick message to the property manager. We’ll get back to you soon.
                  </p>
                  <button className="loft-btn full" onClick={() => setShowApply(true)}>
                    <Icon name="send" /> Apply
                  </button>
                </>
              )}

              <div className="loft-contact-info">
                <h4>Contact Information</h4>
                <div className="loft-contact-item">
                  <Icon name="phone" />
                  <span>{property.contact.phone}</span>
                </div>
                <div className="loft-contact-item">
                  <Icon name="mail" />
                  <span>{property.contact.email}</span>
                </div>
                <div className="loft-contact-item">
                  <Icon name="user" />
                  <span>{property.contact.manager}</span>
                </div>
              </div>
            </div>
          </aside>
        </div>
      </div>

      {/* Apply Modal */}
      {showApply && (
        <div className="loft-modal" role="dialog" aria-modal="true" onClick={() => setShowApply(false)}>
          <div className="loft-dialog" onClick={(e) => e.stopPropagation()}>
            <button className="loft-close" onClick={() => setShowApply(false)} aria-label="Close">
              <Icon name="close" />
            </button>
            <h3 className="loft-dialog-title">Apply / Inquire</h3>

            {/* Error banner */}
            {applyError && (
              <div className="loft-error" role="alert" aria-live="assertive">
                {applyError}
              </div>
            )}

            <form className="loft-form" onSubmit={handleApplySubmit}>
              {/* Hidden context fields */}
              <input type="hidden" name="property" value={property.title} />
              <input type="hidden" name="_subject" value="Loft Inquiry via Harmon Property" />

              <div className="loft-field">
                <label>Name</label>
                <input name="name" placeholder="Your name" required />
              </div>
              <div className="loft-field">
                <label>Email</label>
                <input name="email" type="email" placeholder="you@example.com" required />
              </div>
              <div className="loft-field">
                <label>Phone</label>
                <input name="phone" type="tel" placeholder="Your phone number" />
              </div>
              <div className="loft-field">
                <label>Message</label>
                <textarea name="message" rows={5} />
              </div>

              {/* Google reCAPTCHA */}
              <div className="loft-field">
                <ReCAPTCHA
                  ref={recaptchaRef}
                  sitekey={RECAPTCHA_SITE_KEY}
                  onChange={setCaptchaToken}
                  onExpired={() => setCaptchaToken(null)}
                />
              </div>

              <button className="loft-btn" type="submit" disabled={isSubmitting || !captchaToken}>
                <Icon name="send" /> {isSubmitting ? "Sending..." : "Send Application"}
              </button>
              <button
                type="button"
                className="loft-btn ghost"
                onClick={() => setShowApply(false)}
                disabled={isSubmitting}
              >
                Cancel
              </button>
            </form>
          </div>
        </div>
      )}

      {/* Image Lightbox */}
      {lbOpen && (
        <Lightbox
          images={sampleImages}
          index={lbIndex}
          onClose={() => setLbOpen(false)}
          onPrev={() => setLbIndex((p) => (p - 1 + sampleImages.length) % sampleImages.length)}
          onNext={() => setLbIndex((p) => (p + 1) % sampleImages.length)}
        />
      )}
    </div>
  );
}
